<script setup>
import { computed, inject } from "vue"
import { formatDate } from "../format"

const props = defineProps({ value: { type: String, default: null }, empty: { type: String, default: "Без даты" } })
const me = inject("me", null)
const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
const timeZone = computed(() => {
  const configured = me?.value?.time_zone
  if (!configured || configured === "UTC") return browserTimeZone
  try {
    new Intl.DateTimeFormat("ru-RU", { timeZone: configured }).format()
    return configured
  } catch {
    return browserTimeZone
  }
})
const formatted = computed(() => {
  if (!props.value) return null
  return formatDate(props.value, { timeZone: timeZone.value })
})
</script>

<template><span v-if="formatted" class="dual-time"><strong>{{ formatted }}</strong></span><span v-else>{{ empty }}</span></template>
